import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { type Rotation, rotateClockwise } from '@/utils/rotation';
const useRotation = () => {
  const $ = _c(3);
  const [rotation, setRotation] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setRotation(rotateClockwise);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const rotate = t0;
  let t1;
  if ($[1] !== rotation) {
    t1 = {
      rotation,
      rotate
    };
    $[1] = rotation;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useRotation;